(function () {
    const root = document.getElementById("membershipProducts");
    const goDonateRenewalUrl = root.dataset.godonaterenewalurl;
    const MembershipProducts = Vue.createApp({
        data() {
            return {
                //defaults
                donorId: '',
                gettingMembershipInfo: false,
                emailAddressIsValid: false,
                showValidation: false,
                membershipInfoSuccess: '',
                membershipInfoFailed: false,
                emailAddress: '',
                membershipNumber: '',
                membershipNumberIsValid: false,
                memberTitle: '',
                memberForename: '',
                memberSurname: '',
                memberName: '',
                memberPhone: '',
                memberAddress: '',
                memberAddress2: '',
                memberAddress3: '',
                memberCity: '',
                memberCountry: '',
                memberPostCode: '',
                goDonateRenewalUrl: goDonateRenewalUrl
            };
        },
        computed: {
            goDonateFullRenewalUrl: function () {
                return (this.goDonateRenewalUrl + '?membershipid=' + this.membershipNumber + '&donorId=' + this.donorId);
            },
            memberFullname: function () {
                return (this.memberTitle + ' ' + this.memberForename + ' ' + this.memberSurname).trim();
            }
        },
        methods: {
            renewMyMembership: function () {
                const t = this;
                t.membershipInfoSuccess = "success";
            },
            goBackToMembershipForm: function () {
                const t = this;
                t.membershipInfoSuccess = "";
            },
            getMembershipDetails: function () {
                const t = this;
                if (!t.isValid())
                    return;
                t.gettingMembershipInfo = true;
                t.membershipInfoFailed = false;
                $.get("/umbraco/api/mymembershipapi/getmembershipdetails?email="+t.emailAddress+"&membership_number="+t.membershipNumber)
                    .done(function (response) {
                        if (response.success) {
                            t.donorId = response.model.donorId;
                            t.memberTitle = response.model.hasOwnProperty('Title') && response.model.title !== null ? response.model.title : '';
                            t.memberForename = response.model.forename;
                            t.memberSurname = response.model.surname;
                            t.memberName = response.model.name;
                            t.memberPhone = response.model.mobilePhone;
                            t.memberAddress = response.model.address1 !== null ? response.model.address1 : '';
                            t.memberAddress2 = response.model.address2 !== null ? response.model.address2 : '';
                            t.memberAddress3 = response.model.address3 !== null ? response.model.address3 : '';
                            t.memberCity = response.model.city !== null ? response.model.city : '';
                            t.memberCountry = response.model.country !== null ? response.model.country : '';
                            t.memberPostCode = response.model.postcode !== null ? response.model.postcode : '';
                            t.membershipInfoSuccess = "success";
                        }
                        else {
                            t.membershipInfoFailed = true;
                        }
                                                
                    })
                    .always(function () {
                        t.gettingMembershipInfo = false;
                    });
            },
            isValid: function () {
                const t = this;
                const regex =
                    /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                t.emailAddressIsValid = regex.test(t.emailAddress);
                t.membershipNumberIsValid = t.membershipNumber != '';

                t.showValidation = true;
                return t.emailAddressIsValid && t.membershipNumberIsValid;
                //disableJQuery(); // just for any case. Can't test it in dev environment cus this issue doesn't happen in windows, but happens in Linux and Macos. The JQuery validates the email field and doubles the email errors.
            },
            reset: function () {
                const t = this;
                t.gettingMembershipInfo= false;
                t.emailAddressIsValid= false;
                t.showValidation= false;
                t.membershipInfoSuccess= '';
                t.emailAddress= '';
                t.membershipNumber= '';
                t.membershipNumberIsValid= false;
                t.memberName= '';
                t.memberPhone= '';
                t.memberAddress= '';
                t.memberCity= '';
                t.memberCountry= '';
                t.memberPostCode= '';
            }
        }
    });
    const vm = MembershipProducts.mount('.membership-products');
})();